// extracted by mini-css-extract-plugin
module.exports = {"button":"ChangeCountryLanguage_button__CBDJ7","countryName":"ChangeCountryLanguage_countryName__y6Wo_"};